import { AsyncTasksDto } from '../../models/async-tasks.dto'
import { SyncActionFactory } from '../../../shared/utils/redux/sync.actions'
import { ListActionFactory } from '../../../shared/utils/redux/list/list.actions'

export class AsyncTasksActions {
  public static setAsyncTasks = new ListActionFactory<AsyncTasksDto>(
    '[ASYNC_TASKS] SET ASYNC TASKS',
  )

  public static ackAsyncTasks = new SyncActionFactory<AsyncTasksDto>(
    '[ASYNC_TASKS] ACK ASYNC TASKS',
  )
}
